'use client'


export default function Home() {

  return (
    <main className="flex-grow mb-12 pt-40">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
              Your trusted source for news, information, and stories about the Mountain State. Stay connected with what matters most in West Virginia.
            </p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8">
              <p className="text-lg text-gray-600">Stay updated with the latest news and insights from West Virginia</p>
            </div>
            
            <div className="flex justify-center items-center w-full mb-8">
              <div className="relative rounded-lg shadow-lg overflow-hidden" style={{ width: '100%', maxWidth: '640px', aspectRatio: '16/9' }}>
                <iframe
                  src="https://www.youtube.com/embed/TJP5uIlGqB4?si=aSMe_f8UOhgMP6lp"
                  title="YouTube video player"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>
            
            <div className="text-center">
              <a
                href="https://www.youtube.com/@WestVirginiaWire/featured"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition duration-300"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                Subscribe to West Virginia Wire
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
} 